// src/pages/TermsPage.tsx

import React from "react";
import { appData } from "../data/appData";
import PageConfigurator from "../components/PageConfigurator";
import "../styles/TermsPage.css"; // Create appropriate CSS

const TermsPage: React.FC = () => {
  return <PageConfigurator pageData={appData.pages.terms} pageName="terms" />;
};

export default TermsPage;
